export {default} from './ProgressTarget.connect';
